import { Box } from 'core/components';
import React, { PropsWithChildren } from 'react';

function PlanIconBox({ children }: PropsWithChildren<object>): JSX.Element {
  return (
    <Box mr={2} flex="0">
      {children}
    </Box>
  );
}

export default PlanIconBox;
